import { IsLoggedInUseCase } from './auth/isLoggedInUseCase';
import { GetLeasesUseCase } from './getLeasesUseCase';
import { MagicUseCase } from './magicUseCase';

export class InitializeAppUseCase extends MagicUseCase {
  protected async runLogic() {
    await new IsLoggedInUseCase().execute();
    if (this.getState().user.loginInfo.isLoggedIn) {
      await new GetLeasesUseCase().execute();
    }
  }
}
